import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

const AddIcon: React.FC<FontAwesomeIconProps> = props => <FontAwesomeIcon {...props} />

export default AddIcon;
